export default "__VITE_ASSET__bb161d2f__"